/*!
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

export { default as DialogDefault } from './dialog-default.story';
export { default as DialogTopAligned } from './dialog-top-aligned.story';
export { default as DialogImage } from './dialog-image.story';
export { default as DialogVariants } from './dialog-variants.story';
export { default as DialogInfo } from './dialog-info.story';
export { default as DialogWarning } from './dialog-warning.story';
export { default as DialogDanger } from './dialog-danger.story';

import { removeLicenseHeader } from '../../_common/export-stories-utils';
import DialogDangerSrcRaw from './dialog-danger.story.tsx?raw';
import DialogDefaultSrcRaw from './dialog-default.story.tsx?raw';
import DialogImageSrcRaw from './dialog-image.story.tsx?raw';
import DialogInfoSrcRaw from './dialog-info.story.tsx?raw';
import DialogTopAlignedSrcRaw from './dialog-top-aligned.story.tsx?raw';
import DialogVariantsSrcRaw from './dialog-variants.story.tsx?raw';
import DialogWarningSrcRaw from './dialog-warning.story.tsx?raw';

export const DialogDefaultSrc = removeLicenseHeader(DialogDefaultSrcRaw);
export const DialogTopAlignedSrc = removeLicenseHeader(DialogTopAlignedSrcRaw);
export const DialogVariantsSrc = removeLicenseHeader(DialogVariantsSrcRaw);
export const DialogImageSrc = removeLicenseHeader(DialogImageSrcRaw);
export const DialogInfoSrc = removeLicenseHeader(DialogInfoSrcRaw);
export const DialogWarningSrc = removeLicenseHeader(DialogWarningSrcRaw);
export const DialogDangerSrc = removeLicenseHeader(DialogDangerSrcRaw);
